import {
  ActionButtonProps,
  allThemes,
  Box,
  ColorOptions,
  Form,
  Icon,
  Loader,
  SpacerNew,
  Text,
} from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useEffect, useRef, useState } from 'react'
import LinearGradient from 'react-native-linear-gradient'
import { useLazyApiData, useStores } from '../../data/store'
import { staticStrings } from '../../utils/constants'
import { loginFormData, loginWtPasswordFormData } from './formData'
import styles from './styles'

interface EyeProps {
  showPasswd: boolean
  setShowPasswd: (data: boolean) => void
}

export const textWrapper = <Text>+91</Text>

export const EyeIcon: FC<EyeProps> = ({ showPasswd, setShowPasswd }: EyeProps) => {
  const onPress = () => {
    setShowPasswd(!showPasswd)
  }
  return (
    <Box onPress={onPress} underlayColor="WHITE">
      <Icon id={showPasswd ? 'EYE_WATCH' : 'EYE_WATCH_SELECTED'} color="PRIMARY" size="FONT_SIZE_LARGE" />
    </Box>
  )
}

const Login: FC = () => {
  const [otpSent, setOtpSent] = useState(false)
  const { getUserDetails, generateOtp, verifyOtp, resetToken, signIn } = useStores((store) => ({
    generateOtp: store.session.generateOtp,
    verifyOtp: store.session.verifyOtp,
    getUserDetails: store.user.fetchUserDetails,
    resetToken: store.user.resetToken,
    signIn: store.session.generateVerifyPKCE,
  }))
  const formRef = useRef(null)
  const [showPasswd, setShowPasswd] = useState(false)

  const [appAuth, { state, data }] = useLazyApiData(signIn)
  const [generateOtpApi, { state: generateOtpstate }] = useLazyApiData(generateOtp)
  const [verifyOtpApi, { state: verifyOtpState, data: verifyOtpData }] = useLazyApiData(verifyOtp)
  const [getUserDetailsApi, { state: userApiState, data: userApiData }] = useLazyApiData(getUserDetails)
  const [isPasswordLogin, setIsPasswordLogin] = useState(false)

  const navigation = useNavigation()

  const isLoading = verifyOtpState === 'pending' || generateOtpstate === 'pending' || userApiState === 'pending'
  const themedStyle = styles(1000)

  useEffect(() => {
    if (verifyOtpState === 'fulfilled') {
      if (verifyOtpData?.usrAccessToken?.length > 0) {
        getUserDetailsApi()
      }
    }
  }, [verifyOtpState, verifyOtpData, getUserDetailsApi])

  useEffect(() => {
    if (generateOtpstate === 'fulfilled') {
      setOtpSent(true)
    }
  }, [generateOtpstate])

  useEffect(() => {
    if (state === 'fulfilled') {
      if (data?.usrAccessToken?.length > 0) {
        getUserDetailsApi()
      }
    }
  }, [state])

  useEffect(() => {
    if (userApiState === 'fulfilled') {
      if ((verifyOtpData?.usrAccessToken?.length > 0 || data?.usrAccessToken?.length > 0) && userApiData) {
        navigation.reset({
          index: 0,
          routes: [{ name: 'dashboard', params: { isFromLogin: true } }],
        })
      } else {
        resetToken()
      }
    } else if (userApiState === 'rejected') {
      resetToken()
    }
  }, [verifyOtpData, navigation, resetToken, userApiData, userApiState])

  // useEffect(() => {
  //   if (state === 'fulfilled' && typeof data !== 'undefined') {
  //     if (data?.usrAccessToken?.length > 0) {
  //       getUserDetailsApi()
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [state, data])

  const handleSubmit = ({ values, isValid }: ActionButtonProps) => {
    const handlePress = () => {
      if (isPasswordLogin) {
        console.log('in isPasswordLogin', isPasswordLogin)
        appAuth(values?.userName, values?.password)
      } else if (!otpSent) {
        console.log('in !otpSent', otpSent)
        generateOtpApi(values.userName)
      } else {
        console.log('in verifyOtpApi')
        verifyOtpApi(values.userName, values.otp)
      }
    }

    return (
      <>
        <Box
          {...themedStyle.buttonBgView}
          disabled={!isValid || isLoading}
          backgroundColor={
            isValid ? ('PRIMARY' as ColorOptions) : (allThemes.light.colors.DISABLED_GREY as ColorOptions)
          }
          onPress={handlePress}
          testID={'login-button'}>
          {state === 'pending' ||
          generateOtpstate === 'pending' ||
          verifyOtpState === 'pending' ||
          userApiState === 'pending' ? (
            <Loader type="small" color="WHITE" />
          ) : (
            <Text
              color={
                isValid
                  ? (allThemes.light.colors.WHITE as ColorOptions)
                  : (allThemes.light.colors.GRAY_LIGHT as ColorOptions)
              }
              type="body2">
              {otpSent || isPasswordLogin ? staticStrings.login : staticStrings.sendOtp}
            </Text>
          )}
        </Box>
        <Box
          marginTop={20}
          paddingBottom={4}
          alignItems={'center'}
          onPress={() => setIsPasswordLogin(!isPasswordLogin)}
          underlayColor={'TRANSPARENT'}
          testID={'toggle-login-mode'}>
          <Text color={'BLUE'} fontFamily={'jiotype-medium'}>
            {isPasswordLogin ? 'Login using OTP' : 'Login using password'}
          </Text>
        </Box>
      </>
    )
  }

  const onHandleKeyPress = ({ nativeEvent: { key: keyValue } }) => {
    if (keyValue === 'Enter') {
      console.log(' isPasswordLogin', isPasswordLogin)
      console.log(' otpSent', otpSent)
      const formData = formRef?.current?.getValues() ?? {}
      if (isPasswordLogin) {
        console.log('in isPasswordLogin', isPasswordLogin)
        appAuth(formData?.userName, formData?.password)
      } else if (!otpSent) {
        console.log('in !otpSent', otpSent)
        generateOtpApi(formData.userName)
      } else {
        console.log('in verifyOtpApi')
        verifyOtpApi(formData.userName, formData.otp)
      }
    }
  }

  const callGenerateOtpApi = () => {
    const formData = formRef?.current?.getValues() ?? {}
    generateOtpApi(formData.userName)
  }
  return (
    <LinearGradient
      colors={['#214796', '#1F71A2']}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 0 }}
      style={{ flex: 1, minHeight: '100vh' }}>
      <Box {...themedStyle.container}>
        <Box {...themedStyle.twoColContainer}>
          <Box {...themedStyle.brandColumn}>
            <Box {...themedStyle.brandRow}>
              <Icon id={'JIO_ICON'} color={'WHITE'} size={48} />
              <Text
                title={'Pay Services'}
                color={'WHITE'}
                fontSize={24}
                fontFamily={'jiotype-medium'}
                fontWeight={'600'}
              />
            </Box>
            <SpacerNew direction={'vertical'} size={36} />
            <Text
              title={'Manage your\npayments operations'}
              color={'WHITE'}
              fontSize={44}
              lineHeight={52}
              fontFamily={'jiotype-black'}
              opacity={0.25}
            />
          </Box>

          <Box justifyContent="center" flexDirection="row">
            <Form
              ref={formRef}
              formName="Enter login credentials"
              formData={
                isPasswordLogin
                  ? loginWtPasswordFormData(
                      <EyeIcon showPasswd={showPasswd} setShowPasswd={setShowPasswd} />,
                      showPasswd,
                      onHandleKeyPress,
                    )
                  : loginFormData(onHandleKeyPress, otpSent, setOtpSent, callGenerateOtpApi, generateOtpstate)
              }
              actionButtons={handleSubmit}
              container={FormBox}
            />
          </Box>
        </Box>
      </Box>
    </LinearGradient>
  )
}

const FormBox = ({ children }: any) => {
  return <Box {...styles(1000).formContainer}>{children}</Box>
}

export default Login
